'use strict';

var _ = require('lodash');
var urlJoin = require('url-join');
var userEndpointMixin = require('./user-endpoint-mixin');
var { post } = require('./send-action');
var xhrHelpers = require('xhrhelpers');

function AcceptUserAgreement(getUser, options) {
  this._baseUrl = options.baseUrl;
  this._getUser = getUser;
}

AcceptUserAgreement.prototype.post = function() {
  return this._getUser()
    .then(xhrHelpers.responseObject)
    .then((userData) => {
      var uri = urlJoin(this._baseUrl, 'pb/users', userData.id, 'accept-user-agreement/');
      return post(uri);
    });
};

_.assignIn(AcceptUserAgreement.prototype, userEndpointMixin);

module.exports = AcceptUserAgreement;
